import { IDataTableCellModifiers, IDataTableRow } from '../models';
import React, { FC } from 'react';
import { DataTableCellModifierRightHoverContent } from './_RightHoverContent/DataTableCellValueRightHoverContent';
import { IComponentChildrenProps } from '@src/models/props';
import { useDataTableContext } from '../context';
import { Tooltip } from '@src/atoms/Tooltip';

export interface IDataTableCellModifierProps extends IComponentChildrenProps {
  row: IDataTableRow;
  modifiers?: IDataTableCellModifiers;
}

export const DataTableCellModifier: FC<IDataTableCellModifierProps> = ({ children, modifiers, row }) => {
  const { api } = useDataTableContext();

  if (!modifiers) {
    return <>{children}</>;
  }

  let Component = children;

  if (modifiers.wrap?.callback) {
    Component = modifiers.wrap?.callback(Component, row, api);
  }

  if (modifiers.rightHoverContent?.callback) {
    Component = (
      <DataTableCellModifierRightHoverContent
        rightContentCallback={() => {
          return modifiers.rightHoverContent?.callback(row, api);
        }}
      >
        {Component}
      </DataTableCellModifierRightHoverContent>
    );
  }

  if (modifiers.tooltip?.callback) {
    const tooltipProps = modifiers.tooltip?.callback(row, api);
    if (tooltipProps) {
      Component = <Tooltip {...tooltipProps}>{Component}</Tooltip>;
    }
  }

  return <>{Component}</>;
};
